import $ = require("jquery");
import _ = require("underscore");

export interface ILookupEntityInfo {
    EntityId: string;
    FieldName: string;
    lookupKey?: string;
    resolver?: (result: ILookupEntityResults) => void;
    rejecter?: (error: any) => void;
}
export interface ILookupEntityResults extends ILookupEntityInfo {
    Successful: boolean;
    FriendlyFieldName: string;
    FriendlyTitle: string;
}
export class LookupEntityInfo implements ILookupEntityInfo {
    constructor(fieldName: string, entityId: string) {
        this.FieldName = fieldName;
        this.EntityId = entityId;
    }

    EntityId: string;
    FieldName: string;
}
export class Service {
    private serviceUrl: string;
    private performingLookup: boolean;

    private lookupQueue: ILookupEntityInfo[];

    private hasValidServiceUrl: boolean;

    private static lookupCache: { [key: string]: Promise<ILookupEntityResults> } = {};

    constructor(serviceUrl?: string) {
        this.serviceUrl = serviceUrl;
        if (!this.serviceUrl) {
            this.hasValidServiceUrl = false;
        } else {
            this.hasValidServiceUrl = true;
        }
        this.lookupQueue = [];
    }
    private checkForNewLookups() {
        if (this.lookupQueue.length > 0) {
            if (!this.performingLookup) {
                this.actuallyPerformLookup();
            }
        }
    }
    private generateKey(entityInfo: ILookupEntityInfo) {
        return `${entityInfo.FieldName}_${entityInfo.EntityId}`;
    }
    private actuallyPerformLookup() {
        if (this.lookupQueue.length > 0) {
            this.performingLookup = true;
            const lookups = this.lookupQueue.slice();
            this.lookupQueue = [];


            const p = new Promise<ILookupEntityResults[]>((resolve, reject) => {
                const xhr = $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: this.serviceUrl,
                    data: JSON.stringify(lookups),
                    contentType: "application/json; charset=utf-8"
                });

                xhr.done((result) => {
                    resolve(result);
                }).fail((error) => {
                    reject(error);
                });
            });


            p.then((values) => {
                const resultDict = {};
                _.each(values, (val) => {
                    resultDict[this.generateKey(val)] = val;
                });

                _.each(lookups, (lookup) => {
                    const result = resultDict[lookup.lookupKey];
                    if (result) {
                        lookup.resolver(result);
                    } else {
                        lookup.rejecter("Metadata not found");
                    }
                });

            }, (rejectError) => {
                _.each(lookups, (lookup) => {
                    lookup.rejecter(rejectError);
                });
            }).catch((e) => {
                _.each(lookups, (lookup) => {
                    lookup.rejecter(e);
                });
            }).then(() => {
                this.performingLookup = false;
                this.checkForNewLookups();
            });
        }
    }
    lookupFriendlyTitleInformation(entityInfo: ILookupEntityInfo): Promise<ILookupEntityResults> {
        const key = this.generateKey(entityInfo);

        if (!this.hasValidServiceUrl) {
            return Promise.reject("no service url configured for MetadataService");
        }

        entityInfo.lookupKey = key;

        const cached = Service.lookupCache[key];
        if (cached) {
            return cached;
        }



        const p = new Promise<ILookupEntityResults>((resolve, reject) => {
            entityInfo.resolver = resolve;
            entityInfo.rejecter = reject;
        });

        this.lookupQueue.push(entityInfo);

        this.checkForNewLookups();
        Service.lookupCache[key] = p;
        return p;
    }

}
